import React from 'react';
import b1 from '../assets/Fotografija_6-min.jpg';
import b2 from '../assets/Fotografija_7-min.jpg';
import b3 from '../assets/Fotografija_8-min.jpg';
import b4 from '../assets/Fotografija_9-min.jpg';

const BusinessSuccess = ({toSection,section}) => {
  const businessAreas = [
    {
      title: "Courses",
      description: "Tinker Labs curriculum spans multiple STEAM disciplines, and is designed by experts to build essential skills at each developmental stage, encouraging higher retention rates year over year.",
      imageUrl: b1,
      maxWidth: "w-[300px]"
    },
    {
      title: "Birthday parties",
      description: "Generate extra income by hosting themed birthday parties. With more than 10 STEAM topics, parties are a great way to introduce new students to your learning center and have them sign up to year-long courses.",
      imageUrl: b2,
      maxWidth: "w-[300px]"
    },
    {
      title: "Holiday courses and camps",
      description: "School breaks don't have to mean a pause in the stream of income. Our specially designed holiday courses and camps allow you to keep students and parents happy and occupied even during winter and summer breaks.",
      imageUrl: b3,
      maxWidth: "w-[300px]"
    },
    {
      title: "Themed workshops",
      description: "Some children are only interested in certain topics, that is why we offer quarterly specialized themed workshops where parents can pay-as-you-come. They are also a great way to boost enrolment.",
      imageUrl: b4,
      maxWidth: "w-[300px]"
    }
  ];

  return (
    <div className="relative" id={section}  style={{marginTop: '-90px'}}>
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#c7e7ff"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-[#c7e7ff] relative py-20">
        <div className="container mx-auto px-4">
          <h2 className="font-['Grandstander'] text-4xl font-extrabold text-center text-[#002147] mb-16">
            Education, but also Business Success
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {businessAreas.map((area, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                {/* Image Container */}
                <div className={`${area.maxWidth} aspect-[4/3] mb-6 overflow-hidden rounded-lg`}>
                  <img 
                    src={area.imageUrl} 
                    alt={area.title}
                    className="w-full h-full object-cover hover:opacity-90 transition-opacity"
                  />
                </div>
                
                {/* Content */}
                <div className={`${area.maxWidth}`}>
                  <h3 className="font-['Lexend'] text-xl font-semibold text-[#002147] mb-3">
                    {area.title}
                  </h3>
                  <p className="font-['Lexend'] text-gray-600 text-sm leading-relaxed">
                    {area.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#c7e7ff"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default BusinessSuccess;